import {TsMenuItem} from '@app/shared/_interfaces/menu';
import {turboSMTPApiUrl} from '@config/config';

export const headerMenuItems: TsMenuItem[] =
  [
   {
     icon: 'pi pi-comment',
     label: 'm_livechat',
     id: 'ts_open_chat',
     styleClass: 'support-chat',
    },
    {
      icon: 'pi pi-question',
      styleClass: 'p-menuitem-support hidden lg:block',
      items: [
       /* {
          label: 'm_livechat',
          icon: 'pi pi-fw pi-comments',
          restriction: 'subaccounts'
        },*/
        {
          label: 'm_tickets',
          icon: 'pi pi-fw pi-ticket',
          styleClass: 'external-link',
          target: '_blank',
          routerLink: 'myaccount/tickets',
          restriction: 'subaccounts'
        },
        {
          label: 't_knowledgebase',
          icon: 'pi pi-fw pi-book',
          target: '_blank',
          styleClass: 'external-link',
          routerLink: 'myaccount/knowledgebase',
          restriction: 'subaccounts'
        },
        {
          label: 't_api',
          icon: 'pi pi-fw pi-code',
          styleClass: 'external-link',
          target: '_blank',
          url: turboSMTPApiUrl
        },
      ]
    },
    {
      id: 'username',
      label: 't_username',
      icon: 'pi pi-fw pi-user',
      styleClass: 'hidden lg:block',
      items: [
        {
          id: 'email',
          label: 'm_myaccount',
          styleClass: 'hidden lg:block p-menuitem-link-username',
          routerLinkActiveOptions: {exact: true}
        },
        {
          label: 'm_mydetails',
          icon: 'pi pi-fw pi-user',
          routerLink: '/myaccount/details',
          routerLinkActiveOptions: {exact: true}
        },
        {
          label: 'm_products',
          icon: 'pi pi-fw pi-inbox',
          routerLink: '/myaccount/products',
          restriction: 'subaccounts',
          routerLinkActiveOptions: {exact: true}
        },
        {
          label: 'm_billing',
          icon: 'pi pi-fw pi-money-bill',
          routerLink: '/myaccount/billing',
          restriction: 'subaccounts',
          routerLinkActiveOptions: {exact: true}

        },
        {
          label: 'm_messages',
          icon: 'pi pi-fw pi-envelope',
          routerLink: '/myaccount/messages',
          restriction: 'subaccounts',
          routerLinkActiveOptions: {exact: true}
        },

        {
          separator: true,
          restriction: 'already_configured_sender_domains',
        },
        {
          label: 'm_getting_started',
          icon: 'pi pi-fw pi-send',
          routerLink: '/getting-started',
          restriction: 'already_configured_sender_domains',
          routerLinkActiveOptions: {exact: true}
        },
        {
          separator: true
        },
        {
          id: 'logout',
          label: 't_logout',
          icon: 'pi pi-fw pi-power-off'
        }
      ]

    },
/* MOBILE */

    {
      styleClass: 'p-menuitem-mobile block lg:hidden',
      items: [
        {
          id: 'email',
          label: 'm_myaccount',
          routerLinkActiveOptions: {exact: true}
        },
        {
          separator: true
        },
        {
          label: 'm_mydetails',
          icon: 'pi pi-fw pi-user',
          routerLink: '/myaccount/details',
          routerLinkActiveOptions: {exact: true}
        },
        {
          label: 'm_products',
          icon: 'pi pi-fw pi-inbox',
          routerLink: 'myaccount/products',
          restriction: 'subaccounts',
          routerLinkActiveOptions: {exact: true}
        },
        {
          label: 'm_billing',
          icon: 'pi pi-fw pi-money-bill',
          routerLink: 'myaccount/billing',
          routerLinkActiveOptions: {exact: true}
        },
        {
          label: 'm_messages',
          icon: 'pi pi-fw pi-envelope',
          routerLink: 'myaccount/messages',
          restriction: 'subaccounts',
          routerLinkActiveOptions: {exact: true}
        },
        {
          label: 'm_settings',
          icon: 'pi pi-fw pi-cog',
          routerLink: 'settings',
          routerLinkActiveOptions: {exact: true}
        },
        {
          separator: true,
          restriction: 'already_configured_sender_domains',
        },
        {
          label: 'm_getting_started',
          icon: 'pi pi-fw pi-send',
          routerLink: '/getting-started',
          restriction: 'already_configured_sender_domains',
          routerLinkActiveOptions: {exact: true}
        },
        {
          separator: true
        },
        {
          label: 'm_tickets',
          icon: 'pi pi-fw pi-ticket',
          target: '_blank',
          styleClass: 'external-link',
          routerLink: 'myaccount/tickets',
          restriction: 'subaccounts'
        },
        {
          label: 't_knowledgebase',
          icon: 'pi pi-fw pi-book',
          target: '_blank',
          styleClass: 'external-link',
          routerLink: 'myaccount/knowledgebase',
          restriction: 'subaccounts',
        },
        {
          label: 't_api',
          icon: 'pi pi-fw pi-code',
          target: '_blank',
          styleClass: 'external-link',
          url: turboSMTPApiUrl
        },
        {
          separator: true
        },
        {
          id: 'logout',
          label: 't_logout',
          icon: 'pi pi-fw pi-power-off'
        }
      ]
    }
  ];
